<app-global-loader />
<div [style.zoom]="'0.9'">
<router-outlet></router-outlet>
</div>